import { TextField, MenuItem } from "@mui/material";
import DisplayTextField from "../DisplayTextField";

const NonFoodAllergiesFieldForState = ({ formInfo, Object, handleChange }) => {
  let name = Object.name;
  let Page = Object.Page;
  let label = Object.label;
  let AboveText = Object.AboveText;
  let SpecialCondition = Object.SpecialCondition;

  let Array = [
    //prescription  Medication
    {
      Page: Page,
      TextField: "SelectFieldForObjectState",
      label: label,
      name: name,
      selectValues: ["Yes", "No"],
      onlyAppearIfValueIs: false,
      onlyAppearIfValueIsNot: false,
      withRegardsTo: false,
    },
    {
      Page: Page,
      TextField: "SeveritySelectFieldForObjectState",
      label: "Please tell us the severity of the allergy if triggered",
      name: name + "severity",
      onlyAppearIfValueIs: ["Yes"],
      onlyAppearIfValueIsNot: false,
      withRegardsTo: name,
    },
    //PrescriptionMedicationFieldForObjectState
    {
      Page: "NonFoodAllergiesInfo",
      TextField: "PrescriptionMedicationFieldForObjectState",
      label: "Insect allergies",
      name: name,
      onlyAppearIfValueIs: ["Yes"],
      onlyAppearIfValueIsNot: false,
      withRegardsTo: name,
    },
    {
      Page: Page,
      TextField: "SelectFieldForObjectState",
      label: "Over-the-counter medicine",
      name: name + "otc_medicine",
      selectValues: ["Yes", "No"],
      onlyAppearIfValueIs: ["Yes"],
      onlyAppearIfValueIsNot: false,
      withRegardsTo: name,
      AboveText: (
        <p>
          If required, could the student be provided with an over-the-counter
          medicine, such as an antihistamine, to alleviate any symptoms above as
          a result
        </p>
      ),
    },
    {
      Page: Page,
      TextField: "SelectFieldForObjectState",
      label: "Anything else",
      name: name + "anything_else",
      selectValues: ["Yes", "No"],
      onlyAppearIfValueIs: ["Yes"],
      onlyAppearIfValueIsNot: false,
      withRegardsTo: name,
      AboveText: (
        <p>
          Is there anything else that would be helpful for us to know about this
          allergy
        </p>
      ),
    },
    {
      Page: Page,
      TextField: "TextFieldForObjectState",
      label: "Please specify",
      name: name + "anything_else_specified",
      onlyAppearIfValueIs: ["Yes"],
      onlyAppearIfValueIsNot: false,
      withRegardsTo: name + "anything_else",
    },
  ];

  return (
    <>
      <h2>{label}</h2>
      {AboveText}
      <DisplayTextField
        formInfo={formInfo}
        handleChange={handleChange}
        Object={Array[0]}
      />
      <DisplayTextField
        formInfo={formInfo}
        handleChange={handleChange}
        Object={Array[1]}
      />
      <DisplayTextField
        formInfo={formInfo}
        handleChange={handleChange}
        Object={Array[2]}
      />
      <DisplayTextField
        formInfo={formInfo}
        handleChange={handleChange}
        Object={Array[3]}
      />
      <DisplayTextField
        formInfo={formInfo}
        handleChange={handleChange}
        Object={Array[4]}
      />
      <DisplayTextField
        formInfo={formInfo}
        handleChange={handleChange}
        Object={Array[5]}
      />
    </>
  );
};

export default NonFoodAllergiesFieldForState;
